<div mat-subheader>Effekte</div>
<mat-accordion displayMode="flat">
  <mat-expansion-panel *ngFor="let effect of vorhersage.effects" [disabled]="!hasSubEffects(effect)">
    <mat-expansion-panel-header>
      <mat-panel-title style="color: black">{{effect.name}} - {{effect.value}}</mat-panel-title>
    </mat-expansion-panel-header>
    <mat-list>
      <div mat-subheader>Sub-Effekte</div>
      <mat-list-item *ngFor="let subEffect of effect.subEffects">
        {{subEffect.name}} - {{subEffect.value}}
      </mat-list-item>
    </mat-list>
  </mat-expansion-panel>
</mat-accordion>
<div mat-subheader>Empfehlungen</div>
<mat-expansion-panel *ngFor="let recommendation of vorhersage.recommendations" disabled>
  <mat-expansion-panel-header>
    <mat-panel-title style="color: black">{{recommendation.name}} - {{recommendation.value}}</mat-panel-title>
  </mat-expansion-panel-header>
</mat-expansion-panel>
